<template>
    <div v-if="profile" id="UserProfileView">
        <div class="flex flex-col-reverse sm:flex-row">
            <div class="flex grow items-start space-x-6" :class="{ 'mb-10': !minified, 'mb-4': minified }">
                <ProfileViewLayoutTop
                    :custom-location="communityProfileLocations?.location"
                    :full-name="fullName"
                    :is-anonymous="isAnonymous"
                    minified
                    :preview="preview"
                    :profile="profile"
                    :profile-view-type="profileViewType"
                />
            </div>
        </div>

        <ProfileLongStory
            :favorite-location="communityProfileLocations?.favoriteLocation"
            :is-anonymous="isAnonymous"
            :is-show-talent-preferences="isShowTalentPreferences"
            :is-show-talent-response-form="isShowTalentResponseForm"
            minified
            :preview="preview"
            :profile="profile"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { UserCommunityProfileLocations } from '#shared/types/Community'
import type { UserProfile, UserProfileType } from '#shared/types/User'
import { getFullName } from '#shared/utils'
import ProfileViewLayoutTop from '@/components/common/ProfileViewLayoutTop.vue'
import ProfileLongStory from '@/components/profile/ProfileLongStory.vue'

const props = defineProps({
    profile: {
        type: Object as PropType<UserProfile>,
        required: true
    },
    profileViewType: {
        type: String as PropType<UserProfileType>,
        required: true
    },
    communityProfileLocations: {
        type: Object as PropType<UserCommunityProfileLocations>,
        default: undefined
    },
    minified: {
        type: Boolean,
        default: false
    },
    preview: {
        type: Boolean,
        default: false
    },
    isShowTalentPreferences: {
        type: Boolean,
        default: false
    },
    isShowTalentResponseForm: {
        type: Boolean,
        default: false
    },
    isAnonymous: {
        type: Boolean,
        default: false
    }
})

const fullName = computed(() => getFullName(props.profile))
</script>